// extracted by mini-css-extract-plugin
module.exports = {"Main":"OnHand_Main__1kt2f"};